/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Review Component Styles
 *
 * @file ReviewComponentStyle.jsx
 * @author Murhsid Ahamedh
 */

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import mixins from '../../../assets/styles/mixins.scss';
import CommonStyles from '../../../assets/styles/CommonStyles';
import { DashboardCardRoot } from '../../dashboardCard/styles/DashboardCardStyles';

export const ReviewCardRoot = styled(DashboardCardRoot)({
  '&&': {
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: mixins.lightThemeBgColor2,
    borderRadius: 24,
    padding: 16
  }
});

export const ReviewActionsLeftContainer = styled('div')({
  '&&': {
    width: 'auto'
  }
});

export const ReviewContainer = styled(Box)({
  '&&': {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  }
});

export const ReviewContent = styled(Box)({
  '&&': {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,

    [mixins['mlg-min']]: {
      flexDirection: 'row'
    }
  }
});

export const ReviewLeftCol = styled(Box)({
  '&&': {
    width: 280,

    [mixins['mlg-min']]: {
      flex: '0 0 280px'
    }
  }
});

export const ReviewRightCol = styled(Box)({
  '&&': {
    flex: 1
  }
});

export const LeftAccordionListMenuPaper = styled(Paper)({
  '&&': {
    maxHeight: '500px',
    ...CommonStyles().scrollContainer(
      {
        scrollbarColor: 'rgba(81, 46, 171, 0.15) transparent',
        scrollbarWidth: 8
      }
    ),

    '& *': {
      boxSizing: 'border-box'
    },
    borderRadius: 12
  }
});

export const LeftAccordionListMenuList = styled(MenuList)({
  '&&': {
    minWidth: 342
  }
});
